import { Component, Input } from '@angular/core';

import { ImpersonationFoundStudent } from '../../models/Impersonation';
import { AppService } from '../../services/app.service';
import { ImpersonationService } from '../../services/impersonation.service';

@Component({
    selector: 'app-impersonation',
    templateUrl: './impersonation.component.html',
    styleUrls: ['./impersonation.component.css']
})
export class ImpersonationComponent {
    constructor(
        public app: AppService,
        private impersonation: ImpersonationService
    ) { }

    @Input() showBreadcrumb: boolean = true;
    @Input() showImpersonationInfo: boolean = true;

    impersonationError: string = '';

    get currentUser() {
        return this.app.currentUser;
    }

    set(student: ImpersonationFoundStudent) {
        this.app.addLoading(this.impersonation.start(student)).subscribe();
    }

    remove() {
        this.app.addLoading(this.impersonation.end()).subscribe();
    }

    getId(email: string) {
        if (email && email.indexOf('@') > -1) {
            return email.substring(0, email.indexOf('@'));
        } else {
            return email;
        }
    }
}
